<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ki5o1G/tc-custom/9781416546382.jpg?1730543621104" alt="This image is the cover for the book American Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Legacy
      </h1>
      <p class="bookDescription body article font2">
        <b><i>From the moment of their births, John and Caroline Kennedy occupied a central position in what is generally regarded as the most famous family in the United States, if not the world.</i></b> Even as young children growing up in the White House, their most subtle gestures and actions made headlines.... Yet until now they have not been the subject of a dual biography. In that sense, this volume represents a first.<br/><br/> In <i>American Legacy,</i> #1 <i>New York Times</i> bestselling author C. David Heymann draws upon a voluminous archive of personal interviews to present a telling portrait of John and Caroline Kennedy. A longtime biographer of various members of the Kennedy clan, including Jackie and Robert Kennedy, Heymann covers John's and Caroline's childhood in the White House, the dark aftermath of their father's assassination, their uneasy adolescence, and the many challenges they faced as adults, all under the glaring eye of the media. He reveals John's and Caroline's loving but at times trying relationship with their larger-than-life mother, as well as Jackie's own emotional struggles, romantic relationships, and financial concerns following JFK's death. <br/><br/> Other revelations brought to light for the first time in <i>American Legacy</i> include the assassination attempt made on Jackie just before she gave birth to John; JFK Jr.'s romantic escapades prior to marrying Carolyn Bessette and accounts of the predominantly happy marriage they shared despite criticisms from questionable sources; the shocking report of the autopsy performed on John following the tragic plane crash that killed him, Carolyn, and her sister Lauren; Caroline's rise to become one of the wealthiest women in America and her life now as the sole keeper of her family's magnificently complex legacy. <br/><br/> Utterly compelling and full of new and fascinating details, <i>American Legacy</i> overturns much of what we thought we knew about two of the most talked-about members of the Kennedy family.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C. David Heymann
      </h2>
      
      <p class="authorDescription body article">C. David Heymann (1945-2012) is the author of several <I>New York Times</I> bestselling biographies, including <I>Bobby and Jackie</I>, <I>American Legacy</I>, <I>The Georgetown Ladies' Social Club</I>, and <I>RFK: A Candid Biography of Robert F. Kennedy</I>. He lived in Manhattan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?119c3132